import { render, staticRenderFns } from "./ReportingHighlights.vue?vue&type=template&id=134b1a93&scoped=true&"
import script from "./ReportingHighlights.vue?vue&type=script&lang=js&"
export * from "./ReportingHighlights.vue?vue&type=script&lang=js&"
import style0 from "./ReportingHighlights.vue?vue&type=style&index=0&id=134b1a93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b1a93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VProgressCircular,VRow,VSpacer})
